import { ProgressBar } from "react-bootstrap";
import { GetPageTittle } from "../../services/utils";
export default function UpperProgressBar(props) {
    const now = GetPageTittle()

    return (
        <ProgressBar className="prfl_prgrs">
            <ProgressBar
                variant="success"
                now={((now === 'School') || (now === 'Hospital')) && (props.step === 1 || 2 || 3) ? 33.3 : 20}
                key={1}
                label={((now === 'School') || (now === 'Hospital')) && (props.step === 1 || 2 || 3) ? 33.3 : 20}
                className="prgrs_bar1"
            />
            <ProgressBar
                variant="warning"
                now={((now === 'School') || (now === 'Hospital')) && (props.step === 2 || 3) && (props.step !== 1) ? 33.3 :
                    (now === 'Student') && (props.step === 2 || 3 || 4 || 5) && (props.step !== 1) ? 20 : ''}
                key={2}
                label={((now === 'School') || (now === 'Hospital')) && (props.step === 2 || 3) ? 66.6 : 40}
                className={"prgrs_bar2"}
            />
            <ProgressBar
                variant="danger"
                now={((now === 'School') || (now === 'Hospital')) && props.step === 3 ? 33.3 :
                    (now === 'Student') && (props.step === 1 || 2 || 3) && (props.step !== 1) && (props.step !== 2) ? 20 : ''}
                key={3}
                label={((now === 'School') || (now === 'Hospital')) && (props.step === 2 || 3) ? 100 : 60}
                className={((now === 'School') || (now === 'Hospital')) ? "prgrs_bar5" : "prgrs_bar3"}
            />
            <ProgressBar
                variant="danger"
                now={(now === 'Student') && (props.step === 4 || 5) && (props.step !== 1) && (props.step !== 2) && (props.step !== 3) ? 20 : ''}
                key={4}
                label={80}
                className="prgrs_bar4"
            />
            <ProgressBar
                variant="danger"
                now={(now === 'Student') && (props.step === 5) && (props.step !== 4) ? 20 : ''}
                key={5}
                label={100}
                className="prgrs_bar5"
            />
        </ProgressBar>
    )
}